<div role="main">
  <div class="app-header tw-py-5 tw-px-[15px]">
    <!-- App Title -->
    <div class="app-header-title">
      <div>
        <span [shown]="playerLicenseService.hasProfessionalLicenses()">
          {{ playerLicenseService.getUsedLicenseString() }}
        </span>
      </div>
    </div>
  </div>
  <mat-divider class="light" />
  @if (!hasDisplayFullAccess) {
    <notification-alert
      title="You are not a Display Administrator"
      message="Please contact your display administrator to add a new display."
    />
  }
  <div
    class="tw-px-[15px]"
    rvSpinner="display-loader"
    [rvShowSpinner]="displayService.loadingDisplay"
  >
    <div>
      <h2 class="tw-text-lg tw-font-semibold tw-mt-2.5">
        I have already installed Rise Vision.
      </h2>
      <div class="border-container p-4 mb-5">
        <form
          #displayForm="ngForm"
          id="forms.displayForm"
          role="form"
          name="forms.displayForm"
          autocomplete="on"
          novalidate
        >
          <common-actions
            [actions]="actions"
            [saving]="displayService.savingDisplay"
          >
          </common-actions>

          <div
            class="grid grid-md-col-3 grid-md-gap-4 tw-pt-5 tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-gray-200"
          >
            <div class="grid-cell">
              <div
                class="form-group required"
                [ngClass]="{
                  'has-error':
                    (displayName.dirty || displayForm?.submitted) &&
                    displayName.invalid,
                }"
              >
                <label class="control-label" for="display-name">
                  Display Name:
                </label>
                <input
                  #displayName="ngModel"
                  name="displayName"
                  id="display-name"
                  type="text"
                  class="form-control"
                  [(ngModel)]="displayService.display.name"
                  placeholder="Name your new display"
                  required
                />
                <p
                  [shown]="
                    (displayName.dirty || displayForm?.submitted) &&
                    displayName.invalid
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Please enter a name for your display.
                </p>
              </div>
            </div>
            <div class="grid-cell">
              <div class="form-group">
                <label class="control-label" for="activation-key">
                  Activation Code:
                </label>
                <input
                  #activationKey
                  name="activationKey"
                  id="activation-key"
                  autocomplete="off"
                  maxlength="5"
                  type="text"
                  class="form-control"
                  [ngClass]="{
                    u_uppercase: displayService.display.activationKey,
                  }"
                  [(ngModel)]="displayService.display.activationKey"
                  (ngModelChange)="detectChanges()"
                  placeholder="Enter the code shown on your display"
                />
              </div>
            </div>
            <div class="grid-cell">
              <div class="form-group">
                <preview-selector
                  [(selectedItem)]="selectedSchedule"
                  additionalClass="label-d-block"
                  label="Schedule:"
                ></preview-selector>
              </div>
            </div>
          </div>
          <div
            id="errorBox"
            [shown]="displayService.apiError"
            class="madero-style alert alert-danger u_margin-md-top"
            role="alert"
          >
            <strong>{{ displayService.errorMessage }}</strong>
            {{ displayService.apiError }}
          </div>
        </form>
      </div>
      <h2 class="tw-text-lg tw-font-semibold tw-mt-2.5">
        I have not installed Rise Vision or activated my display.
      </h2>
      <div class="border-container mb-5">
        <div class="not-installed grid grid-md-col-3 grid-inner-borders">
          <div class="grid-cell py-4 px-5">
            <div class="flex-col space-between">
              <div>
                <h3 class="tw-text-base tw-font-bold">
                  Use Existing Media Player
                </h3>
                <p class="mb-4">
                  If you already have a existing dedicated media player, get
                  started by installing Rise Vision.
                </p>
              </div>
              <div class="grid grid-col-2 grid-inner-borders align-center mb-4">
                <div class="grid-cell p-3">
                  <img
                    alt="Windows logo"
                    src="/images/install/windows.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Ubuntu logo"
                    src="/images/install/ubuntu.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Amazon Fire TV Stick logo"
                    src="/images/install/amazonsignagestick.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Chrome OS logo"
                    src="/images/install/chrome.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3 py-4">
                  <img
                    alt="BrightSign logo text"
                    src="/images/install/brightsign.svg"
                    width="70"
                    height="15"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Raspberry Pi logo"
                    src="/images/install/raspberrypi.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Android logo"
                    src="/images/install/android.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Apple TV logo"
                    src="/images/install/appletv.png"
                    width="40"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">
                  <img
                    alt="Web Player icon - computer monitor display"
                    src="/images/install/web-player.svg"
                    width="35"
                    height="30"
                  />
                </div>
                <div class="grid-cell p-3">&nbsp;</div>
              </div>
              <p class="mb-4">
                We also support IFPDs and collaboration screens.
                <a
                  rv-link
                  appearance="inline"
                  target="_blank"
                  href="https://help.risevision.com/hc/en-us/sections/115000832963-Collaboration-Displays"
                  >Learn More</a
                >
              </p>
              <div class="flex-row justify-end mb-3">
                <a rv-button variant="secondary" uiSref="apps.displays.install"
                  >Install Rise Vision</a
                >
              </div>
            </div>
          </div>
          <div class="grid-cell py-4 px-5 u_position-relative">
            <div class="or-label">OR</div>
            <div class="flex-col space-between">
              <div>
                <h3 class="tw-text-base tw-font-bold">
                  Preview Virtual Display
                </h3>
                <p class="mb-4">
                  No Display, No Problem, preview our virtual display right here
                  in your browser.
                </p>
              </div>
              <img
                class="img-fluid"
                alt="A classroom with a display screen showing a weather forecast."
                src="/images/install/classroom-preview.jpg"
              />
              <div class="flex-row justify-end mt-4 mb-3">
                <button
                  rv-button
                  variant="secondary"
                  type="button"
                  class="tw-shrink-0 tw-whitespace-nowrap"
                  (click)="showPreview()"
                >
                  Preview Virtual Display
                </button>
              </div>
            </div>
          </div>
          <div class="grid-cell py-4 px-5 u_position-relative">
            <div class="or-label">OR</div>
            <div class="flex-col space-between">
              <div>
                <h3 class="tw-text-base tw-font-bold">
                  Purchase Rise Vision Media Player
                </h3>
                <p class="mb-4">
                  Purchase outright or leave the management and support to us,
                  and purchase as a subscription hardware service plan. Now
                  featuring
                  <a
                    rv-link
                    appearance="inline"
                    targert="_blank"
                    href="https://help.risevision.com/hc/en-us/articles/20745351943700"
                    >bulk activation</a
                  >.
                </p>
                <div
                  class="grid grid-col-2-1 grid-md-col-2 grid-lg-col-2-1 grid-align-center mb-3"
                >
                  <div class="grid-cell">
                    <img
                      class="img-fluid"
                      alt="Rise Vision Media Player"
                      src="/images/install/media-player.png"
                    />
                  </div>
                  <div class="grid-cell pl-4">
                    <small
                      ><em
                        >Currently only available in the
                        <span class="u_nowrap">United States.</span></em
                      ></small
                    >
                  </div>
                </div>
                <p>
                  Need a display too? Get the Avocor R Series hardware as a
                  service (no media player required).
                  <a
                    rv-link
                    appearance="inline"
                    tabindex="0"
                    (click)="helpWidgetService.showContactUs()"
                    (keyup.enter)="helpWidgetService.showContactUs()"
                    >Contact Sales</a
                  >
                </p>
                <div class="flex-row justify-end mt-4 mb-3">
                  <a
                    rv-button
                    variant="secondary"
                    href="https://help.risevision.com/hc/en-us/articles/18468794812180"
                    target="_blank"
                    >Learn More</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
